import { render } from "./RenderMarkdown.vue?vue&type=template&id=78f6bafa&scoped=true"
import script from "./RenderMarkdown.vue?vue&type=script&lang=js"
export * from "./RenderMarkdown.vue?vue&type=script&lang=js"

import "./RenderMarkdown.vue?vue&type=style&index=0&id=78f6bafa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-78f6bafa"

export default script